import React, { useState, Fragment, useEffect } from 'react';
import { Dialog, Button, Checkbox } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';

const ProtectLawTipInner = (props) => {
  const [showDialog, setShowDialog] = useState(false);
  const [checkLaw, setCheckLaw] = useState(0);
  useEffect(() => {
    RPCFactory.operationUser
      .getLawStatusById(window.pageProps.uid)
      .done((data) => {
        setShowDialog(!data);
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  }, []);

  const logout = (event) => {
    RPCFactory.sso
      .logout()
      .done((data) => {
        window.location.href = '/';
      })
      .fail((ret, msg) => {
        window.alert(`退出失败，错误信息：${msg}`);
      });
  };
  const onConfirm = () => {
    setShowDialog(false);
    RPCFactory.operationUser
      .updateLawStatus(window.pageProps.uid)
      .done(() => {
        setShowDialog(false);
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };
  return (
    <Fragment>
      <Dialog
        backdrop
        type="normal"
        className="dialog-protect-raw"
        style={{ width: '960px', height: '630px' }}
        hideFooter
        hideHeader
        show={showDialog}
      >
        <div className="self-header">线索管理平台服务协议</div>
        <div className="law-detail">
          <div className="law-content">
            <p>欢迎您使用线索管理平台！</p>
            <p>本协议是您与腾讯之间就您使用线索管理平台服务（以下简称“本服务”或“本功能”） 所订立的协议。</p>
            <p>
              请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。
            </p>
            <p>
              除非您已阅读并接受本协议所有条款，否则您无权使用本服务。您点击勾选同意本协议，或对本服务的注册/登录、查看、设置、使用等行为即视为您已阅读并同意本协议的约束。
            </p>
            <p>
              您有违反本协议的任何行为时，腾讯有权依照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。
            </p>
            <br />
            <p className="law-item-title">第一条 协议的范围</p>
            <p>
              1.1
              本协议内容同时包括腾讯可能不断发布的关于本服务的相关协议、服务声明、业务规则及公告指引等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。
            </p>
            <p className="law-item-title">第二条 术语定义</p>
            <p>
              2.1
              广告线索数据：是指您通过本服务管理的包括但不限于个人信息、业务数据等广告业务数据，这些数据：（1）由您委托腾讯发布广告收集并传输到本服务中，此场景下您作为数据处理者向用户收集相关信息；（2）由您通过其他方式收集并传输到本服务中。
            </p>
            <p className="law-item-title">第三条 服务内容</p>
            <p>
              3.1
              本服务是指腾讯广告旗下免费的线索管理工具，广告主在腾讯投放广告后获得的线索，会自动进入线索管理平台，您可以在该平台查看/下载/外呼/标注线索信息。本服务的载体包括但不限于PC/APP/小程序/公众号/企业微信等，具体以您实际使用的为准。
            </p>
            <p className="law-item-title">第四条 您的权利和义务</p>
            <p>4.1 资质要求：</p>
            <p>为使用本服务，您保证：</p>
            <p>（1）您具备依据法律法规等要求及经营需要可能需要具备的所有条件。</p>
            <p>
              （2）您使用本服务的行为及所提供的相关信息、内容，均符合国家相关法律法规的规定，且不违反您和任何第三方所签署的在先协议；
            </p>
            <p>
              （3）您所提供的各项信息均真实、合法、有效；必要时，腾讯有权要求您提交或补充提交上述各项相关的证明文件。
            </p>
            <p>
              若您不能满足上述保证事项的，腾讯有权拒绝为您开通服务或终止向您提供全部或部分服务，对因此而造成的损失或责任，您应独自承担；如因此给腾讯及/或其关联公司造成了损失的，您还应当赔偿。
            </p>
            <p>
              4.2
              如您将本服务中的数据提供给第三方处理，您需遵守服务的相关规则和技术要求，确保第三方以不低于本服务所采取的数据保护标准对数据进行保护，并对该提供行为以及后续可能发生的一切衍生问题承担责任，包括但不限于赔偿由此给腾讯、第三方及与数据相关的用户造成的一切损失、消除不良影响等。
            </p>
            <p>
              4.3
              您应当对您使用本服务的行为负责，您不得从事任何包括但不限于以下的违反法律法规、政策及公序良俗、社会公德或干扰本服务正常运营和侵犯腾讯、第三方合法权益的行为，也不得为以下行为提供便利：
            </p>
            <p>（1）反对宪法确定的基本原则的；</p>
            <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
            <p>（3）损害国家荣誉和利益的；</p>
            <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；煽动地域歧视、地域仇恨的；</p>
            <p>（5）破坏国家宗教政策，宣扬邪教和迷信的；</p>
            <p>（6）散布谣言，扰乱社会秩序、破坏社会稳定的；</p>
            <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
            <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
            <p>（9）对他人进行暴力恐吓、威胁，实施人肉搜索的；</p>
            <p>（10）涉及他人隐私、个人信息或资料的；</p>
            <p>（11）散布污言秽语，损害社会公序良俗的；</p>
            <p>（12）侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；</p>
            <p>（13）散布不良广告信息，或类似的商业招揽信息、过度营销信息及垃圾信息，或开展传销活动的；</p>
            <p>（14）未经腾讯同意，自行修改商品展示信息形式的；</p>
            <p>（15）未经腾讯许可，以任何方式使用腾讯的URL地址、技术接口等；</p>
            <p>
              （16）任何虚假交易及流量作弊的行为（包括但不限于自行或煽动他人重复点击/访问、通过不正当手段变相鼓励用户点击/访问、通过程序软件、作弊软件自动点击或访问、刷单、以任何不正当方式提升或试图提升商品展示信息的交易数据）；
            </p>
            <p>（17）以其他任何不正当手段、方式制造虚假展示量、点击量或下载量等情形的；</p>
            <p>
              （18）使用未经腾讯授权或许可的任何插件、外挂、系统或第三方工具对本服务的正常运行进行干扰、破坏、修改或施加其他影响；
            </p>
            <p>（19）利用或针对本服务进行任何危害计算机网络安全的行为，包括但不限于：</p>
            <p className="margin-left-20">a.使用未经许可的数据或进入未经许可的服务器/帐号；</p>
            <p className="margin-left-20">b.未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</p>
            <p className="margin-left-20">
              c.未经许可，企图探查、扫描、测试腾讯系统或网络的弱点或其它实施破坏网络安全的行为；
            </p>
            <p className="margin-left-20">
              d.企图干涉、破坏腾讯系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；
            </p>
            <p className="margin-left-20">e.伪造TCP/IP数据包名称或部分名称；</p>
            <p className="margin-left-20">
              f.对本软件（包括小程序、移动应用等形式）进行反向工程、反向汇编、编译或者以其他方式尝试发现本软件的源代码；
            </p>
            <p className="margin-left-20">g.恶意注册帐号，包括但不限于频繁、批量注册帐号；</p>
            <p className="margin-left-20">h.其它危害腾讯或任意第三方计算机网络安全的行为。</p>
            <p>
              （20）其他违反法律法规、政策及公序良俗、干扰腾讯任何产品正常运营或侵犯任何第三方合法权益内容的其他信息。
            </p>
            <p>
              在任何情况下，如果腾讯有理由认为您的任何行为属于或可能属于上述约定情形的，腾讯可独立进行判断并处理，且在任何时候有权在进行任何事先通知的情况下终止向您提供服务，并追究相关责任。
            </p>
            <p>
              4.4
              未经腾讯事先书面同意，不得擅自将您的注册账号转让给或者授权他人使用，并且您应对通过您的帐号所进行的一切活动承担全部责任。
            </p>
            <p>
              4.5
              您在任何情况下都不得私自使用腾讯的包括但不限于包含“腾讯”、“微信”、本软件/服务名称等在内的任何商标、服务标记、商号、域名、网站名称或其他显著品牌特征等（以下统称为“标识”
              ）。未经腾讯事先书面同意，您不得将前述标识以单独或结合其他任何信息的方式展示、使用或申请注册商标、进行域名注册等，也不得向他人明示或暗示您或与您有关的第三人有权展示、使用或以其他方式处理该等标识。由于您违反本协议使用腾讯上述标识给腾讯或他人造成损失的，由您承担全部法律责任。
            </p>
            <p>
              4.6本协议的签署，不代表您与腾讯之间构成任何劳动法律层面的劳动、劳务、雇佣关系；任何情况下，您均应独立承担因使用本服务而产生的法律责任。
            </p>
            <p className="law-item-title">第五条 腾讯的权利和义务</p>
            <p>
              5.1
              您清楚知悉并理解，腾讯在本协议项下仅为您提供技术支持服务，包括但不限于接受您的委托对您提供的广告线索数据进行存储、展示、整理、筛选、统计、分析等。腾讯不对相关广告线索数据的真实性、准确性、时效性负责。
            </p>
            <p>
              5.2
              腾讯有权依据运营管理需要随时终止您所传输至本服务中的多项及/或单一信息、限制或禁止您使用全部或部分本服务，或终止本协议。
            </p>
            <p>
              5.3
              腾讯有权制定与本服务相关的管理规范，相关规范一经公布即成为本协议不可分割的一部分。对于腾讯根据相关法律法规规定及平台管理规范做出的管理措施和决定，您应同样遵守。
            </p>
            <p>
              5.4
              腾讯向您提供本服务，保留向您收费的权利。如未来腾讯需向您收费，腾讯将在相应服务页面进行通知或公告，确保您有充分选择的权利。如果您不同意相关付费服务，则应停止使用本服务。
            </p>
            <p className="law-item-title">第六条 违规认定与处理</p>
            <p>
              6.1
              针对您违反本协议或其他管理规范的行为，腾讯有权独立判断并视情况采取预先警示、警告、拒绝发布、限期改正、删除内容、立即停止传输信息、限制相关帐号部分或者全部功能直至永久关闭帐号等措施，同时，保留追究相应法律责任的权利。腾讯有权公告处理结果，且有权根据实际情况决定是否恢复使用。对涉嫌违法犯罪的行为将保存在案、并依法向有关政府部门调查时如实报告。
            </p>
            <p>
              6.2
              腾讯有权根据本协议、本服务相关规则和您的违约行为对您注册的本服务账号及其它腾讯或其关联公司运营平台的相关账户采取资金划扣、止付、解除止付等措施。您不可撤销地授权腾讯在本协议有效期内对您的账号、帐户采取资金划扣、止付、解除止付等措施，您认可该指令的法律后果。
            </p>
            <p>
              6.3
              因您在使用本服务违反法律法规、侵犯第三方的权利可能会引起其他第三方追偿或处罚。若因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行承担全部法律责任。因您的违法或违约行为导致腾讯及其关联公司、控制公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿腾讯及其关联公司、控制公司因此遭受的全部损失。
            </p>
            <p className="law-item-title">第七条 免责声明</p>
            <p>
              7.1
              您知悉并同意：签署本协议，并不代表腾讯保证必然向您提供本服务。腾讯有权根据产品计划和运营情况独立决定本服务开启、暂停、终止的具体时间、试点时长以及本服务的具体内容，前述决定不经通知即生效，腾讯不对此向您承担任何责任。腾讯不保证您对本服务的使用不会中断或不出现错误。您同意，腾讯可能不经通知不时移除本服务接入的内容或暂停、终止提供本服务。腾讯不保证本服务能够免于网络故障、损失、攻击、病毒、干扰、黑客或其他安全侵入。
            </p>
            <p>
              7.2
              您理解并同意，本协议是为保障遵守国家法律法规、维护公序良俗，保护他人合法权益，腾讯在能力范围内尽最大的努力按照相关法律法规进行判断而制定并执行，但并不保证腾讯判断完全与司法机关、行政机关的判断一致，如因此产生的后果您已经理解并同意自行承担。
            </p>
            <p>
              7.3
              您同意，您自愿承担使用本服务的风险。本服务以及通过本服务提供给您的所有产品功能、服务均按现状提供，腾讯不对此进行任何明示或暗示的保证，包括收益、特定适用性、不侵权等。本服务的相关服务内容及结果仅供您参考，无法充分保证及时性、准确性和完整性，请您谨慎使用。如您基于本服务反馈的服务结果进行决策而遭受任何损失，您同意免于追究本服务的相关责任。
            </p>
            <p>
              7.4
              您了解并同意，腾讯仅为本服务的技术提供方，并非专业司法机构，仅能在腾讯的合法权限和能力范围内对您提交的申请信息或资质证明进行合理、谨慎的形式评估和判断，但腾讯无法实质审查您的实际经营、运营以及推广等行为，并不为此提供任何担保。
            </p>
            <p>
              7.5
              在使用本服务过程中，如您违反本协议或本协议项下承诺或有其他非法、超授权、不合理使用本服务的行为而导致任何诉讼、索赔、争议，您承诺保障与本服务有关的腾讯、腾讯员工、关联公司、代理商、承包商等免受其害，并保证将代为解决，承担相关责任和所有支出（包括律师费、相关赔偿、罚金等）。
            </p>
            <p>
              7.6
              在任何情况下，腾讯均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害（包括因您使用本服务而遭受的利润损失）承担责任。腾讯对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用本服务而应获得的收益。
            </p>
            <p className="law-item-title">第八条 信息保护</p>
            <p>
              8.1
              腾讯将会采取合理的措施保护您向腾讯提交的信息及相关服务数据。除法律法规规定的情形外，腾讯不会向第三方公开、透露上述信息。腾讯对相关信息采用专业加密存储与传输方式，保障您的信息安全。
            </p>
            <p>
              8.2
              您在使用本服务过程中，需要填写或授权腾讯一些必要的信息，请保持这些信息的真实、准确、合法、有效并注意及时更新，以便腾讯向您提供及时有效的帮助，或更好地提供服务。若填写的信息不完整或不准确，则可能无法使用本服务或在使用过程中受到限制。
            </p>
            <p>
              8.3
              若您在使用本服务的过程中收集、存储、处理或使用其他用户的个人数据及信息的，应当遵守法律、行政法规有关个人信息保护的规定，以及腾讯与您订立的相关协议。
            </p>
            <p className="law-item-title">第九条 知识产权</p>
            <p>
              9.1
              除另有特别声明外，本服务所依托软件的著作权、专利权及其他知识产权均归腾讯所有。上述及其他任何腾讯依法拥有的知识产权均受到法律保护，未经腾讯书面许可，您不得以任何形式进行使用或创造相关衍生作品。
            </p>
            <p className="law-item-title">第十条 违约处理</p>
            <p>
              10.1
              针对您违反本协议或其他服务条款、违法违规或侵犯第三方合法权益的行为，腾讯有权独立判断并视情况采取预先提示、立即停止传输信息、不结算收入、限制帐号部分或者全部功能、终止提供服务直至永久关闭帐号等措施。腾讯有权公告处理结果，且有权根据实际情况决定是否恢复相关帐号或功能的使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为，腾讯将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。如因违反本协议协议，导致服务功能关闭或帐号被封禁的，您同时将被处以不得提取全部未结算、未提现收益的措施。
            </p>
            <p>
              10.2
              因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行处理并承担可能因此引起的全部法律责任。因您的违法或违约等行为导致腾讯及/或其关联公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿腾讯及/或其关联公司因此遭受的全部损失。
            </p>
            <p>
              10.3
              腾讯尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用本服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，腾讯有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应当自行处理并承担可能因此引起的全部法律责任；如因您的侵权行为导致腾讯及/或其关联公司遭受损失的（包括经济、商誉等损失），您还应足额赔偿腾讯及/或其关联公司遭受的全部损失。
            </p>
            <p className="law-item-title">第十一条 通知</p>
            <p>
              11.1
              腾讯会以网页公告、网页/弹窗提示、电子邮箱、手机短信、常规的信件传送、站内信等方式中的一种或多种，向您送达关于本服务的各种规则、通知、提示等信息，该等信息一经腾讯采取前述任何一种方式公布或发送，即视为送达，对您产生约束力。若您不接受，请停止使用本服务，否则视为您已经接受、同意。
            </p>
            <p>
              11.2
              若由于您提供的电子邮箱、手机号码、通讯地址等信息错误，导致您未收到相关规则、通知、提示等信息的，您同意视为已经收到相关信息并受其约束，一切后果及责任由您自行承担。
            </p>
            <p>
              11.3 您同意腾讯或合作伙伴可以向您的电子邮件、手机号码等发送其他各类信息包括但不限于商业广告、推广信息等。
            </p>
            <p className="law-item-title">第十二条 其他</p>
            <p>
              12.1您使用本服务的行为即视为已阅读并同意受本协议的约束。腾讯有权在必要时修改本协议。您可以在相关服务页面查阅最新版本的条款，本协议变更后，如果继续使用本服务，即视为接受修改后的协议。如果不接受修改后的协议，应当停止使用本服务。
            </p>
            <p>
              12.2本协议签订地为中华人民共和国广东省深圳市南山区。一切与本协议有关的争议均由本协议签订地有管辖权的人民法院管辖。
            </p>
            <p>12.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
            <p className="signature">腾讯公司</p>
          </div>
        </div>
        <Checkbox
          className="law-check"
          value="1"
          checked={checkLaw}
          onChange={(e, value) => {
            setCheckLaw(value);
          }}
        >
          我已阅读并同意《线索管理平台服务协议》
        </Checkbox>
        <div className="pay-module-btn call-module-btn">
          <Button onClick={() => logout()} className="pay-module__btn law-cancel-btn">
            退出登录
          </Button>
          <Button
            onClick={() => onConfirm()}
            className="pay-module__btn law-confirm-btn"
            displayType="primary"
            disabled={!checkLaw}
          >
            确定
          </Button>
        </div>
      </Dialog>
    </Fragment>
  );
};

export const ProtectLawTip = React.memo(ProtectLawTipInner);
